import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { EXTERNAL_REQUEST } from '@core-utils';
import { Observable } from 'rxjs';
import { LandingPageResponseDto, PromoBrandResponseDto } from '../dto';

@Injectable()
export class LandingPageApiService {
  private http = inject(HttpClient);

  private route = 'promos/landing-page';
  private brandsRoute = 'promos/brands';

  getLandingPage(
    campaignId: string,
  ): Observable<LandingPageResponseDto | null> {
    return this.http.get<LandingPageResponseDto | null>(
      `${this.route}/${campaignId}`,
    );
  }

  updateLandingPage(campaignId: string, formData: FormData): Observable<void> {
    return this.http.put<void>(`${this.route}/${campaignId}`, formData);
  }

  getBrand(brandId: string): Observable<PromoBrandResponseDto> {
    return this.http.get<PromoBrandResponseDto>(
      `${this.brandsRoute}/${brandId}`,
    );
  }

  getImage(url: string): Observable<Blob> {
    return this.http.get(url, {
      responseType: 'blob',
      context: new HttpContext().set(EXTERNAL_REQUEST, true),
    });
  }

  getAdminBrand(
    organizationId: string,
    brandId: string,
  ): Observable<PromoBrandResponseDto> {
    return this.http.get<PromoBrandResponseDto>(
      `admin/promos/organizations/${organizationId}/brands/${brandId}`,
    );
  }
}
